<template>
  <v-row class="flex-column mt-6 pr-8">
    <v-col class="custom-panel">
      <v-row class="flex-column">
        <v-col class="custom-panel__header">
          Add Licensee
          <v-btn icon @click="$router.push('/licences')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-col>
        <v-form v-model="valid" class="form-right-view-lable">
          <v-col class="custom-form mt-5">
            <v-row no-gutters>
              <v-col sm="2"
                ><label class="custom-form__label">Company *</label></v-col
              >
              <v-col sm="8">
                <v-text-field v-model="company" :rules="companyRules" filled autofocus/>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col sm="2"
                ><label class="custom-form__label">Company Email *</label></v-col
              >
              <v-col sm="8">
                <v-text-field
                  v-model="companyEmail"
                  :rules="emailRules"
                  filled
                />
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col sm="2"
                ><label class="custom-form__label">Tier Type *</label></v-col
              >
              <v-col sm="4">
                <v-select
                  v-model="selectedTierType"
                  :item-text="(item) => item.tierName"
                  :items="tierList"
                  :item-value="(item) => item.id"
                  filled
                  append-icon="expand_more"
                  label="Select"
                  @change="(emailRows = []), tierByID()"
                />
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col sm="2"
                ><label class="custom-form__label"
                  >Products Included</label
                ></v-col
              >
              <v-col sm="9">
                <v-tabs
                  v-model="model"
                  class="custom-tabs"
                  slider-color="white"
                >
                  <v-tab
                    v-for="(product, i) in productList"
                    :key="i"
                    :href="'#tab-' + product.name"
                    >{{ product.name }}</v-tab
                  >

                  <v-tabs-items v-model="model" class="custom-tabs__cont">
                    <v-tab-item
                      v-for="(product, i) in productList"
                      :key="i"
                      :value="'tab-' + product.name"
                    >
                      <v-row
                        v-for="(row, index) in emailRows.filter(
                          (el) => el.productId === product.id,
                        )"
                        :key="index"
                        no-gutters
                        class="emp_row"
                      >
                        <v-col sm="3"
                          ><label class="custom-form__label"
                            >Employee Email *</label
                          ></v-col
                        >
                        <v-col sm="5" class="pr-8"
                          ><v-text-field
                            v-model="row.email"
                            :rules="emailRules"
                            filled
                            @input="userEmailCheck(product)"
                          />
                          <p
                            v-if="
                              isDuplicate &&
                              index ===
                                emailRows.filter(
                                  (el) => el.productId === product.id,
                                ).length -
                                  1
                            "
                            style="color: red"
                          >
                            Duplicated email
                          </p>
                        </v-col>
                        <v-col class="no-wrap mt-2" sm="3"
                          ><v-checkbox v-model="row.check" label="Super Admin"
                        /></v-col>
                        <v-col sm="1" class="no-wrap mt-2">
                          <v-btn
                            :disabled="
                              isDuplicate ||
                              emailRows.filter(
                                (el) => el.productId === product.id,
                              ).length >= product.users ||
                              row.email.length < 1
                            "
                            icon
                            @click="addRow(product)"
                          >
                            <v-icon
                              color="#7F7F7F"
                              size="18"
                              class="font-weight-bold"
                              >add</v-icon
                            >
                          </v-btn>
                          <v-btn
                            v-if="index > 0"
                            icon
                            @click="deleteRow(index, product, row.email)"
                          >
                            <v-icon
                              color="#7F7F7F"
                              size="16"
                              class="font-weight-bold"
                              >close</v-icon
                            >
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-tab-item>
                  </v-tabs-items>
                </v-tabs>
              </v-col>
            </v-row>
            <v-row>
              <font color="red" class="v-virtual-table">{{ text }}</font>
            </v-row>
            <v-row>
              <v-col class="text-center mt-8">
                <v-btn
                  :disabled="!valid || buttonCheck() || isDuplicate"
                  class="primary_btn small"
                  depressed
                  @click="addLicence"
                  >Create</v-btn
                >
              </v-col>
            </v-row>
          </v-col>
        </v-form>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions } from 'vuex';
import { storeActions } from '@/store/actions.constants';
export default {
  data: () => ({
    valid: false,
    company: null,
    companyEmail: null,
    tierTypes: [],
    model: 'tab-2',
    isDuplicate: false,
    emailRows: [],
    selectedTierType: null,
    tierData: [],
    text: '',
    licenseObj: {},
    emailRules: [
      (v) => !!v || 'Email required',
      (v) => /@.+\..+/.test(v) || 'Invalid email',
    ],
    companyRules: [
      (v) => !!v || 'Company required',
      (v) =>
        /^[a-zA-Z][a-zA-Z0-9\s ]{2,19}$/.test(v) ||
        'Special characters and Initial numbers are not allowed and string length must be between 3 to 20.',
    ],
  }),
  computed: {
    tierList() {
      return this.tierTypes.map((tier) => ({
        id: tier.id,
        tierName: tier.tier_name,
      }));
    },
    productList() {
      let products = [];
      this.tierData.map((el) => {
        if (el.product_id === 1)
          products.push({
            id: el.product_id,
            name: 'TED',
            users: el.no_of_users,
          });
        if (el.product_id === 2)
          products.push({
            id: el.product_id,
            name: 'Mobe',
            users: el.no_of_users,
          });
        if (el.product_id === 3)
          products.push({
            id: el.product_id,
            name: 'PACE',
            users: el.no_of_users,
          });
      });
      return products;
    },
  },
  async mounted() {
    let res = await this.getTierDetails();
    this.tierTypes = res.data;
  },
  methods: {
    ...mapActions({
      createLicense: 'licensees/createLicense',
      getTierList: 'licensees/getTierList',
      getTierDetails: 'licensees/getTierDetails',
      getTierById: 'licensees/getTierById',
      getLicense: 'licensees/getLicense',
    }),
    async addLicence() {
      this.emailRows = this.emailRows
        .filter((item) => item.email != null)
        .map((el) => ({
          email: el.email,
          check: el.check,
          roleId: el.check === true ? 6 : 7,
          productId: el.productId,
        }));
      // const licenseObj = {
      //   organization_name: this.company,
      //   primary_email_id: this.companyEmail,
      //   tier_id: this.selectedTierType,
      //   employeeEmails: this.emailRows,
      // };
      // this.$store.dispatch(`users/${storeActions.loginAction}`, usrObj).then((res) => console.log(res))

      this.licenseObj = await this.createLicense({
        organization_name: this.company,
        primary_email_id: this.companyEmail,
        tier_id: this.selectedTierType,
        employeeEmails: this.emailRows,
      });
      // .then((res) => {
      if (this.licenseObj.status === 200) {
        this.$router.push('/licences');
        this.$store.dispatch(`snackbar/${storeActions.setSnackbarText}`, {
          text: 'License Created Successfully',
          timeout: 1000,
          color: 'success',
        });
        //   this.getLicense();
      } else {
        this.text = this.licenseObj.data.message;
      }
      // })
      // .catch((err) => {
      //   // Skip login until API and schema got finalise
      //   this.$router.push('/licences');
      //   console.error(err);
      // });
    },
    getTierList() {
      this.getTierDetails({
        tier_id: this.selectedTierType,
      });
    },
    tierByID() {
      const tierPayload = {
        tier_id: this.selectedTierType,
      };
      this.getTierById(tierPayload)
        .then((res) => {
          this.text = null;
          this.isDuplicate = false;
          this.tierData = res.data.products;

          this.tierData.forEach((element) => {
            this.emailRows.push({
              email: '',
              check: false,
              productId: element.product_id,
            });
          });
        })
        .catch((err) => {
          this.$store.dispatch(`snackbar/${storeActions.setSnackbarText}`, {
            text: err.response.data.message,
            timeout: 3000,
            color: 'error',
          });
          //
          // Skip login until API and schema got finalise
          console.error(err);
        });
    },
    buttonCheck() {
      let row = this.emailRows.filter((el) => el.email == '');
      // console.log(row);
      var check = (val) => val.check === false;
      if (
        this.companyEmail == null ||
        this.selectedTierType == null ||
        row.length > 0 ||
        this.emailRows.every(check)
      ) {
        return true;
      } else {
        return false;
      }
    },
    userEmailCheck(product) {
      let row = this.emailRows.filter((el) => el.productId == product.id);

      if (row.length > 1) {
        let index = row.length - 1;
        let _email = row[index].email;
        this.isDuplicate = false;
        row.forEach((item, index) => {
          
         if (item.email.toLowerCase()==_email.toLowerCase() && index != row.length - 1 )
          {
            this.isDuplicate = true;
          }
        })
        // let count = this.emailRows.filter(
        //   (item, index) =>
        //     item.email == _email && index != this.emailRows.length - 1,
        // ).length;
        // if (count > 0) {
        //   this.isDuplicate = true;
        // } else {
        //   this.isDuplicate = false;
        // }
      }
    },
    // userEmailCheck(product) {
    //   let row = this.emailRows.filter((el) => el.productId == product.id);
    //   if (row.length > 1) {
    //     let index = row.length - 1;
    //     let _email = row[index].email;
    //     let count = row.filter(
    //       (item, index) => item.email == _email && index != row.length - 1,
    //     ).length;
    //     // console.log(count);
    //     if (count > 0) {
    //       this.isDuplicate = true;
    //       // console.log(this.isDuplicate);
    //     } else {
    //       this.isDuplicate = false;
    //     }
    //   }
    // },
    addRow: function (product) {
      // console.log(this.emailRows);
      this.emailRows.push({ email: '', check: false, productId: product.id });
    },

    deleteRow(mainIndex, product, email) {
      // let row = this.emailRows.filter((el,index) => el.productId === product.id && el.email=== email);

      // if (this.emailRows.length > 1) {
      //   this.emailRows.splice(index, 1);
      // }
      let ind = this.emailRows.findIndex(
        (el) => el.productId === product.id && el.email === email,
      );
      // console.log(ind);
      this.emailRows.splice(ind, 1);
      this.isDuplicate = false;
      this.userEmailCheck(product);
      // this.emailRows.forEach((el, index) => {
      //   if (el.productId === product.id && el.email === email) {
      //     this.emailRows.splice(index, 1);
      //   }
      // });
    },
  },
};
</script>

<style lang="scss" scoped>
.no-wrap {
  white-space: nowrap;
}
</style>
